import React from 'react'
import styled from 'styled-components'
import globalConfirmation from 'live/services/global-confirmation'
import i18n from 'live/services/i18n'

interface Props {
    remove?: Function
    model?: String
}

export default function DeleteTemplate({ model, remove }: Props) {
    return (
        <Container
            data-cy="DeleteTemplate"
            onClick={() =>
                globalConfirmation.danger(
                    'Are you sure to remove this model? ',
                    'Spreadsheets that are using this model will need to be re-imported.',
                    () => remove(model)
                )
            }
        >
            <Icon className="fa fa-trash-alt" />
            <span>{i18n('Delete Database')}</span>
        </Container>
    )
}

const Container = styled.div`
    height: 100%;
    width: 100%;
    padding: 0 0.8rem; 
    position: relative;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: 'row';
    cursor: pointer;

    span {  
        font-family: 'Source Sans Pro', sans-serif; 
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;

        color: #d9534f;
    }
`
const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    color: #d9534f;
    margin-right: 1rem;
`
